export default {
  globalLoading: [],
  msgBox: {
    type: 'txt',
    msg: '',
  },
}
